export enum AwsEventLogAction {
  Allowed = 'allowed',
  Blocked = 'blocked',
}

export interface AwsEventLogEntry {
  srcPort: number
  srcIp: string
  destIp: string
  proto: string
  action: AwsEventLogAction // Using the AwsEventLogAction enum
  firewallName: string
  flowId: number
  host: string | null
  destPort: number
  sni: string | null
  timestamp: Date
}

export interface AwsEventLogsResponse {
  events: AwsEventLogEntry[]
  nextToken?: string // Token for paginated results
  awsConsoleUrl?: string
}
